module.exports = __webpack_public_path__ + "img/dsbResult.0c414c44.png";